import { render, staticRenderFns } from "./rpterctstdapprove.vue?vue&type=template&id=0c457dcc&"
import script from "./rpterctstdapprove.vue?vue&type=script&lang=js&"
export * from "./rpterctstdapprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports